export const ON_CHANGE_DEBOUNCE_TIMER = 300;
export const RESIZE_DEBOUNCE_TIMER = 250;
export const SLIDE_CHANGE_DEBOUNCE_TIMER = 300;

export const VALUE_PATTERNS = {
  boolean: /^(true|false)$/,
  number: /^\d+(\.\d+)?$/,
  array: /^\[(.*)\]$/,
};

// TODO: Test removing optionValueSelectionChange and doing merge
export const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  cartItemValidationChange: 'cart-item-validation-change',
};

export const OKENDO_USER_ID = 'c373606a-6b4e-4588-9dd1-0e0e019a6896';
export const OKENDO_BASE_URL = 'https://api.okendo.io/v1';
export const OKENDO_STORE_URL = `${OKENDO_BASE_URL}/stores/${OKENDO_USER_ID}`;
export const OKENDO_WRITE_REVIEW_URL = `https://okendo.reviews/?subscriberId=${OKENDO_USER_ID}&productId=shopify-[product-id]&locale=en`;

export const REVIEW_STAR_SVG = `
  <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none" aria-hidden="true" aria-focusable="false">
    <path d="M16.5013 2.6687L20.6213 11.0154L29.8346 12.362L23.168 18.8554L24.7413 28.0287L16.5013 23.6954L8.2613 28.0287L9.83463 18.8554L3.16797 12.362L12.3813 11.0154L16.5013 2.6687Z" fill="#01472A"/>
  </svg>
`;

export const ARROW_NEXT_SVG = `
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M6.19922 5.198C6.19922 4.2486 7.24951 3.67519 8.04813 4.18858L18.629 10.9906C19.3638 11.4629 19.3638 12.5371 18.629 13.0094L8.04813 19.8114C7.24951 20.3248 6.19922 19.7514 6.19922 18.802V5.198Z" fill="#262626" />
  </svg>
`;

export const ARROW_PREV_SVG = `
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M17.8008 18.802C17.8008 19.7514 16.7505 20.3248 15.9519 19.8114L5.37098 13.0094C4.63619 12.5371 4.63619 11.4629 5.37098 10.9906L15.9519 4.18859C16.7505 3.67519 17.8008 4.2486 17.8008 5.198L17.8008 18.802Z" fill="#262626"/>
  </svg>
`;

export const stateCodeMapping = {
  AL: 'Alabama',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export const stateNameToCodeMapping = Object.fromEntries(
  Object.entries(stateCodeMapping).map(([code, name]) => [name, code])
);

export const lineItemPropStrings = {
  pickedDate: '_picked-a-date',
  arrivalDateISO: '_arrival-date-in-iso',
  groupKey: '_groupKey',
  feeProductAdded: '_fee-product-added',
  addOnProductAdded: '_add-on-product-added',
  addOn: '_addon',
  feeProductsIds: '_fee-products-ids',
  feeProductHandle: '_fee-product-handle',
  corporateGroupKey: '_corporateGroupKey',
  corporateGift: '_corporate-gift',
  egift: '_e-gift',
  type: '_type',
  isPreorder: '_is-preorder',
  preorderDiscountAmount: '_preorder-discount-amount',
  preorderDiscountType: '_preorder-discount-type',
  privatePreorder: '_private-preorder',
  generalPreorder: '_general-preorder',
  boardVariantId: '_board-variant-id',
  egiftVariantId: '_egift-variant-id',
  productId: '_product-id',
  giftFrom: '_from',
  giftMessage: '_message',
  giftMessageEnabled: '_message_field_enabled',
  isOvernightDelivery: '_is_overnight_delivery',
  isDessertBoard: '_is_dessert_board',
  overnightShippingPrice: '_overnight_shipping_price',
  shippingCharge: '_shipping_charge',
};

// Remove these properties from cart item properties when duplicating to prevent the copied item from having the same properties
export const propertiesToRemoveWhenDuplicate = [
  'Address',
  'Recipient email',
  '_address-first-name',
  '_address-last-name',
  '_address-address',
  '_address-address1',
  '_address-address2',
  '_address-city',
  '_address-state',
  '_address-country',
  '_address-province',
  '_address-zip',
  '_address-phone',
  '_address-email',
  '_note',
  '_first-name',
  '_last-name',
  '_message',
  '_from',
];
